import * as React from 'react';
import { useEffect, useState } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { useQuery } from 'react-query';
import Avatar from '@mui/material/Avatar';
import apiClient from '../../request/http-common';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import { Button } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { Link as RouterLink } from 'react-router-dom';
import { useMutation } from 'react-query';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';

export default function ListPlans() {
    const [plans, setplans] = useState(null);
    const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
    const [planToDelete, setPlanToDelete] = useState(null);
    
    const { isLoading: isLoadingplans, refetch: getplans } = useQuery(
        "investment-plans",
        async () => {
          return await apiClient.get("/api/investment-plans");
        },
        {
          enabled: false,
          onSuccess: (res) => {
            if (res.data.status === 'success') {
                setplans(res.data.plans);
                const event2 = new Event('processed');
                window.dispatchEvent(event2);
            }
          },
          onError: (err) => {
            // console.log(err.response?.data || err);
          },
        }
      );
    
      useEffect(() => {
        getplans() 
        if (isLoadingplans) {
            const event3 = new Event('processing');
            window.dispatchEvent(event3);
        }
      }, []);

    const { mutate: deletePlan, isLoading: isDeleting } = useMutation(
        async (planId) => {
          return await apiClient.delete(`/api/delete-investment-plan/${planId}`);
        },
        {
          onSuccess: (res) => {
            localStorage.setItem('notification', JSON.stringify({message : `${res.data.message}`, 'type': 'success' }));
            const event = new Event('newMessage');
            window.dispatchEvent(event);
            setDeleteDialogOpen(false);
            setPlanToDelete(null);
            getplans();
          },
          onError: (err) => {
            const errorMessage = err.response?.data?.message || 'Failed to delete plan';
            localStorage.setItem('notification', JSON.stringify({message : errorMessage, 'type': 'error' }));
            const event = new Event('newMessage');
            window.dispatchEvent(event);
          },
        }
      );

    const handleDeleteClick = (plan) => {
        setPlanToDelete(plan);
        setDeleteDialogOpen(true);
    };

    const handleDeleteConfirm = () => {
        if (planToDelete) {
            deletePlan(planToDelete.id);
        }
    };

  const getDate = (date) => new Date(date).toDateString();
  return (
    <div style={{marginTop: '75px'}}>
    <Container>
        <Typography  mt={4} mb={2} sx={{ fontWeight: 'bold', fontSize: 20, textAlign: 'center', textTransform: 'uppercase' }} gutterBottom variant="h6" component="div">
        
        {isLoadingplans? 'Loading Plans...' : 'List of Investment Plans'}
      </Typography>
    <TableContainer component={Paper}>
        
      {plans !== null &&
      <Table sx={{ minWidth: '100%' }} size="small" aria-label="a dense table">
      <TableHead>
        <TableRow>
        
        <TableCell>Name</TableCell>
          <TableCell align="right">Min Amount</TableCell>
          <TableCell align="right">Max Amount</TableCell>
          <TableCell align="right">Number of Downlines</TableCell>
          <TableCell align="right">Bonus Per Downline</TableCell>
          <TableCell align="right">Total Earning</TableCell>
          <TableCell align="right">Initial Earning</TableCell>
          <TableCell align="right">Duration</TableCell>
          <TableCell align="right">Category</TableCell>
          <TableCell align="right">Actions</TableCell>
          <TableCell align="right">Date</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {plans.map((plan) => (
          <TableRow
            key={plan.id}
            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
          >
            <TableCell component="th" scope="row">
            {plan.name}
            </TableCell>
            <TableCell align="right">{plan.min_amount}</TableCell>
            <TableCell align="right">{plan.amount_invested}</TableCell>
            <TableCell align="right">{plan.number_of_downlines}</TableCell>
            <TableCell align="right">{plan.bonus_per_downline}%</TableCell>
            <TableCell align="right">{plan.total_earning}</TableCell>
            <TableCell align="right">{plan.initial_earning}</TableCell>
            <TableCell align="right">{plan.duration}</TableCell>
            <TableCell align="right">{plan.category?.name || 'N/A'}</TableCell>
            <TableCell align="right">
              <Button 
                component={RouterLink} 
                to={`/edit-plan/${plan.id}`} 
                startIcon={<EditIcon />}
                size="small"
                sx={{ marginRight: 1 }}
              >
                Edit
              </Button>
              <Button 
                onClick={() => handleDeleteClick(plan)}
                startIcon={<DeleteIcon />}
                color="error"
                size="small"
              >
                Delete
              </Button>
            </TableCell>
            <TableCell align="right">{getDate(plan.created_at)}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
      }
      
    </TableContainer>
    </Container>
    
    <Dialog
      open={deleteDialogOpen}
      onClose={() => setDeleteDialogOpen(false)}
    >
      <DialogTitle>Delete Investment Plan</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Are you sure you want to delete the plan "{planToDelete?.name}"? This action cannot be undone.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setDeleteDialogOpen(false)}>Cancel</Button>
        <Button onClick={handleDeleteConfirm} color="error" variant="contained" disabled={isDeleting}>
          {isDeleting ? 'Deleting...' : 'Delete'}
        </Button>
      </DialogActions>
    </Dialog>
    </div>
  );
}